// export const BASE_URL = "https://devadmin.excelwater.ca/";
// export const BASE_URL = window.location.hostname.includes("excelwater.ca") ? "https://admin.excelwater.ca/" : "https://devadmin.excelwater.ca/";

// export const BASE_URL = "http://192.168.29.191/Excelwater-CRM-API/";
export const BASE_URL = "https://devcrmapi.excelwater.ca/";

export const API_URL = BASE_URL + "public/api/user/";

export const STRIPE_PUB_KEY = "pk_test_51Sx8qYBdND4j0UXdflYowrJhXmwjX3lyzlCy8NpANIFO0KybN6VNVEzl1wNp61CA0nISC2rColKdmvXvGZM3ZSLA00pf1OfAsU";

export const RE_CAPTCHA_SITE_KEY = "6LcKiFgqAAAAANV02lOjPdTqPTL0_MLpXBRxncGu";

//header
export const API_GET_DATA = "get-data";

//login
export const API_LOGIN = "login";
export const API_LOGOUT = "logout";
export const API_REGISTER = "registration"; // ok
export const API_GET_PWD_RESET_LINK = "forgot-password "; // ok
export const API_RESET_PASSWORD = "reset-password"; // ok
export const API_VERIFY_TOKEN = "verify-token"; // ok

//account-details
export const API_GET_PROFILE = "get-profile"; // ok
export const API_UPDATE_PROFILE = "update-profile"; // ok
export const API_CHANGE_PASSWORD = "change-password"; // ok
export const API_ADD_ADDRESS = "add-address";     // ok
export const API_LIST_ADDRESS = "address-list";   // ok
export const API_UPDATE_ADDRESS = "update-address"; //ok
export const API_DELETE_ADDRESS = "delete-address"; // ok
export const API_GET_ADDRESS = "get-address"; // ok
export const API_GIFT_CARD_ORDER_LIST = "gift-card-order-list";  // use nathi
export const API_GIFT_CARD_ORDER_DETAILS = "gift-card-order-details";  //
export const API_LIST_PRODUCT = "product-list"; // ok
export const API_DETAIL_PRODUCT = "product-details"; // ok  
export const API_GET_SHOPPING_CART_PRODUCTS = "get-shopping-cart-products"; //ok

//checkout
export const API_LIST_ORDER = "order-list";  // ok
export const API_DETAILS_ORDER = "order-details";  // ok
export const API_PLACE_ORDER = "place-order"; // ok
export const API_PRINT_INVOICE = "print-invoice"; // ok

export const API_GET_FILTER_DATA = "get-filter-data";  //
export const API_PRODUCT_REVIEW = "product-review";
export const API_GET_PRODUCT_REVIEW = "get-products-reviews";
export const API_CONTACT_US = "contact-us";  // okk
export const API_HOME = "home";  // image 
export const API_GET_GIFT_CARD_AMOUNTS = "get-gift-card-amounts";   //
export const API_GIFT_CARD_PLACE_ORDER = "gift-card-place-order";    //
export const API_APPLY_GIFT_CARD = "apply-gift-card";
export const API_APPLY_GIFT_CARD_OTP = "apply-gift-card-otp";
export const API_PAYMENT_SUCCESS = "payment-success";
export const API_PAYMENT_FAIL = "payment-fail";
export const API_PARTNER_WITH_US = "partner-with-us";   // ok

// Warranty Registration
export const API_WARRANTY_REGISTRATION = "warranty-registration";